export default {
  months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split(
    '_'
  ),
  monthsShort: 'ene._feb._marz_abr._may_jun_jul._ago_sept._oct._nov._dic.'.split('_'),
  monthsParseExact: true,
  weekdays: 'Lunes_Martes_Miércoles_Jueves_Viernes_Sábado_Domingo'.split('_'),
  weekdaysShort: 'lun._mar._mier._jue._vier._sab._dom.'.split('_'),
  weekdaysMin: 'Lu_Ma_Mi_Ju_Vi_Sa_Do'.split('_'),
  weekdaysParseExact: true,
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    LLL: 'D MMMM YYYY HH:mm',
    LLLL: 'DD MMM YYYY',
  },
  calendar: {
    sameDay: '[Hoy a] LT',
    nextDay: '[Mañana a] LT',
    nextWeek: 'dddd [a] LT',
    lastDay: '[Ayer a] LT',
    lastWeek: 'dddd [útlimo a] LT',
    sameElse: 'L',
  },
  relativeTime: {
    future: 'en %s',
    past: 'hay %s',
    s: 'algunos segundos',
    m: 'un minuto',
    mm: '%d minutos',
    h: 'una hora',
    hh: '%d horas',
    d: 'un día',
    dd: '%d días',
    M: 'un mes',
    MM: '%d mes',
    y: 'un año',
    yy: '%d años',
  },
  dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
  ordinal: function(number) {
    return number + (number === 1 ? 'er' : 'e');
  },
  meridiemParse: /PD|MD/,
  isPM: function(input) {
    return input.charAt(0) === 'M';
  },
  // In case the meridiem units are not separated around 12, then implement
  // this function (look at locale/id.js for an example).
  // meridiemHour : function (hour, meridiem) {
  //     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
  // },
  meridiem: function(hours, minutes, isLower) {
    return hours < 12 ? 'PD' : 'MD';
  },
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4, // The week that contains Jan 4th is the first week of the year.
  },
};



// WEBPACK FOOTER //
// ./src/translations/momentLocaleStrings.js